(function () {
  // Load more functionality for blog
  var BlogLoadMore = {
    loadedArticleIds: [],

    init: function () {
      this.setupEventListeners();
      this.trackInitialArticles();
    },

    // Track articles that are already loaded on the page
    trackInitialArticles: function () {
      var articleCards = document.querySelectorAll(".m-article-card");
      var self = this;

      articleCards.forEach(function (article) {
        var articleLinks = article.querySelectorAll("a");
        if (articleLinks && articleLinks.length > 0) {
          var articleUrl = articleLinks[0].getAttribute("href");
          var articleId = self.getArticleIdFromUrl(articleUrl);
          if (articleId) {
            self.loadedArticleIds.push(articleId);
          }
        }
      });
    },

    // Extract article ID from URL
    getArticleIdFromUrl: function (url) {
      if (!url) return null;

      var matches = url.match(/\/blogs\/[^\/]+\/([^\/]+)/);
      return matches ? matches[1] : null;
    },

    setupEventListeners: function () {
      var loadMoreButton = document.querySelector(".load-more-button");
      if (loadMoreButton) {
        loadMoreButton.addEventListener(
          "click",
          this.loadMoreArticles.bind(this)
        );
      }
    },

    loadMoreArticles: function (event) {
      var self = this;
      var button = event.target;
      var blogHandle = button.getAttribute("data-blog-handle");
      var currentPage = parseInt(button.getAttribute("data-current-page"));
      var totalPages = parseInt(button.getAttribute("data-total-pages"));
      var view = button.getAttribute("data-view");
      var nextPage = currentPage + 1;

      if (nextPage <= totalPages) {
        // Show spinner, hide button
        var buttonWrapper = button.closest(".m-blog__load-more");
        var spinner = buttonWrapper.querySelector(".load-more-spinner");

        button.classList.add("hidden");
        spinner.classList.remove("hidden");

        // Fetch the next page
        fetch("/blogs/" + blogHandle + "?page=" + nextPage + "&view=ajax")
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            // Add new articles to the list
            var blogList = document.querySelector(".m-blog__list");
            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;

            var newArticles = tempDiv.querySelectorAll(".m-article-card");
            var articlesAdded = 0;

            // Filter out already loaded articles
            newArticles.forEach(function (article) {
              var articleLinks = article.querySelectorAll("a");
              if (articleLinks && articleLinks.length > 0) {
                var articleUrl = articleLinks[0].getAttribute("href");
                var articleId = self.getArticleIdFromUrl(articleUrl);

                if (
                  articleId &&
                  self.loadedArticleIds.indexOf(articleId) === -1
                ) {
                  // This is a new article, add it
                  self.loadedArticleIds.push(articleId);
                  blogList.appendChild(article);
                  articlesAdded++;

                  // Initialize any animations if needed
                  if (article.classList.contains("m-scroll-trigger")) {
                    setTimeout(function () {
                      article.classList.add("animate--active");
                    }, 100);
                  }
                }
              }
            });

            // Update button data
            button.setAttribute("data-current-page", nextPage);

            // Hide spinner, show button (if there are more pages and we added articles)
            spinner.classList.add("hidden");
            if (nextPage < totalPages && articlesAdded > 0) {
              button.classList.remove("hidden");
            } else {
              buttonWrapper.remove(); // Remove the button completely
            }
          })
          .catch(function (error) {
            console.error("Error loading more articles:", error);
            spinner.classList.add("hidden");
            button.classList.remove("hidden");
          });
      }
    },
  };

  // Initialize on DOM ready
  document.addEventListener("DOMContentLoaded", function () {
    BlogLoadMore.init();
  });
})();
